var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { createContext, useContext, useMemo, useState } from 'react';
import { templatesAtom } from "../../../../../../atoms";
import { useAtomValue } from 'jotai';


import { formatTemplatesToOptions } from "../../../utils/formatters";
import { filterPXQualifiedTemplates } from "../../../utils/filterPXQualifiedTemplates";


















export const CreateExtractorContext = /*#__PURE__*/createContext(
  undefined
);

export const CreateExtractorProvider =


({ children, setShowModal }) => {
  const templates = useAtomValue(templatesAtom);
  const [step, setStep] = useState(1);

  const [targetTemplateId, setTargetTemplateId] = useState('');
  const [sourceTemplateId, setSourceTemplateId] = useState('');
  const [paragraphPropertyId, setParagraphPropertyId] = useState('');
  const [paragraphNumberPropertyId, setParagraphNumberPropertyId] = useState('');
  const [relationshipId, setRelationshipId] = useState('');

  const targetTemplateOptions = formatTemplatesToOptions(
    templates.filter(filterPXQualifiedTemplates)
  );

  const value = useMemo(
    () => ({
      targetTemplateId,
      setTargetTemplateId,
      sourceTemplateId,
      setSourceTemplateId,
      paragraphPropertyId,
      setParagraphPropertyId,
      paragraphNumberPropertyId,
      setParagraphNumberPropertyId,
      relationshipId,
      setRelationshipId,
      targetTemplateOptions,
      step,
      setStep,
      setShowModal
    }),
    [
    targetTemplateId,
    sourceTemplateId,
    paragraphPropertyId,
    paragraphNumberPropertyId,
    relationshipId,
    targetTemplateOptions,
    step,
    setShowModal]

  );

  return (/*#__PURE__*/
    _jsx(CreateExtractorContext.Provider, { value: value }, void 0, children));

};

export const useCreateExtractorContext = () => {
  const context = useContext(CreateExtractorContext);
  if (context === undefined) {
    throw new Error('useCreateExtractor must be used within an CreateExtractorContext');
  }
  return context;
};